import * as React from "react";
import { autorun } from "mobx";
import { inject, observer } from "mobx-react";
import { IntentMediaProps, IntentMediaWizardMapping } from "./typings";
import { mapWizardState, mapContext, pageIdMapper } from "./mappers";
import { logger } from "bernie-core";
import { INTENT_MEDIA_ERROR } from "src/config/systemEvents";

@logger("IntentMedia")
@inject("context", "wizardState")
@observer
export class IntentMedia extends React.Component<IntentMediaProps> {
  private window: any;
  private lastLob: string;

  constructor(props: IntentMediaProps) {
    super(props);
    this.triggerExitUnit = this.triggerExitUnit.bind(this);
  }

  private triggerExitUnit(e: CustomEvent) {
    const contextData = mapContext(this.props.context);
    const wizardData = mapWizardState(e.detail);
    try {
      if (!this.window.IntentMedia) {
        throw new Error("IntentMedia module missing");
      }
      if (!contextData) {
        throw new Error("Unable to map context");
      }
      if (!wizardData) {
        throw new Error("Unabled to map WizardState");
      }
      if (!this.window.meso || !this.window.meso.adcontext) {
        throw new Error("meso module missing");
      }

      this.window.meso.adcontext.push({
        ...contextData,
        ...wizardData,
      });
    } catch (e) {
      if (this.props.logger) {
        this.props.logger.logEvent(INTENT_MEDIA_ERROR, e);
      }
    }
  }

  public componentDidMount() {
    this.window = window;
    this.window.meso = this.window.meso || {};
    this.window.meso.adcontext = this.window.meso.adcontext || [];
    this.window.IntentMedia = this.window.IntentMedia || {};

    // triggers the loading of the intent media script
    const contextData = mapContext(this.props.context);

    if (this.props.wizardState && this.props.wizardState.activeLob) {
      this.window.meso.adcontext.push({
        ...contextData,
        ...{ page_id: pageIdMapper(this.props.wizardState.activeLob) },
      });
    }

    window.addEventListener("IntentMediaSubmit", this.triggerExitUnit);

    // This code listens to the wizardState for changes.
    autorun(() => {
      if (
        this.window.IntentMedia &&
        this.window.IntentMedia.trigger &&
        this.props.wizardState &&
        this.props.wizardState.activeLob !== this.lastLob
      ) {
        this.window.meso.adcontext.push({
          ...contextData,
          ...{ page_id: pageIdMapper(this.props.wizardState.activeLob) },
        });

        this.lastLob = this.props.wizardState.activeLob;
        this.window.IntentMedia.trigger("refresh");
      }

      if (this.props.wizardState && this.props.wizardState.globalWizardState.formSubmitted) {
        const intentMediaMapping: IntentMediaWizardMapping = {
          lob: this.props.wizardState.activeLob,
          wizardState: this.props.wizardState,
        };
        window.dispatchEvent(new CustomEvent("IntentMediaSubmit", { detail: intentMediaMapping }));
      }
    });
  }

  public render() {
    return <meso-intent-media />;
  }
}

export default IntentMedia;
